export default __webpack_public_path__ + "static/media/dgt_houston.b68ffaa8.png";